import React, { useEffect, useState } from "react";
import { collection, addDoc, query, where, orderBy, onSnapshot, getDocs } from "firebase/firestore";
import { auth, db } from "../../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import Search from "./Search";
import FoodCard from "./FoodCard";
import "./Home.css";
import Ranking from "./Ranking"; 


const Home = () => {
  const [foods, setFoods] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [popularFoods, setPopularFoods] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [foodName, setFoodName] = useState("");
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // 로그인 상태 확인
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchFoods = async () => {
      try {
        // 실시간으로 모든 음식 데이터 가져오기
        const foodQuery = query(collection(db, "foods"), orderBy("avgScore", "desc"));
        const unsubscribe = onSnapshot(foodQuery, (querySnapshot) => {
          const foodList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setFoods(foodList);

          // 인기 음식은 상위 3개만 추출
          setPopularFoods(foodList.slice(0, 3));
        });

        return () => unsubscribe(); // 컴포넌트 언마운트 시 구독 해제
      } catch (error) {
        console.error("Error fetching foods:", error);
      }
    };

    fetchFoods();
  }, []);

  const handleSearch = async (searchTerm) => {
    if (!searchTerm.trim()) {
      setSearchResult([]);
      return;
    }

    try {
      const q = query(
        collection(db, "foods"),
        where("name", ">=", searchTerm.trim()),
        where("name", "<=", searchTerm.trim() + "\uf8ff")
      );
      const querySnapshot = await getDocs(q);
      const results = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSearchResult(results);
    } catch (error) {
      console.error("Error searching foods:", error);
      setSearchResult([]);
    }
  };

  const handleAddFoodClick = () => {
    if (!user) {
      alert("음식을 추가하려면 로그인이 필요합니다.");
      navigate("/login");
      return;
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFoodName("");
  };

  const handleAddFood = async () => {
    if (!foodName.trim()) {
      alert("음식 이름을 입력하세요.");
      return;
    }

    try {
      const q = query(collection(db, "foods"), where("name", "==", foodName.trim()));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        alert("이미 존재하는 음식입니다!");
        return;
      }

      await addDoc(collection(db, "foods"), { name: foodName.trim(), clicks: 0, avgScore: 0 });
      alert("음식이 추가되었습니다!");
      handleCloseModal();
    } catch (error) {
      console.error("Error adding food:", error);
      alert("오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  return (
    <div className="home-container">
      <div className="top-bar">
        <div className="logo-section" onClick={() => (window.location.href = "/")}>
          <img src={require("../../assets/wiki_logo.png")} alt="속편한 Wiki" className="wiki-logo" />
        </div>
        <button className="add-food-button" onClick={handleAddFoodClick}>
          음식 추가하기
        </button>
      </div>
      <p className="community-text">
        더 많은 정보를 원한다면?{" "}
        <a
          href="https://open.kakao.com/o/g2ohsN2g" // 여기에 실제 오픈채팅방 링크를 입력하세요
          target="_blank"
          rel="noopener noreferrer"
          className="community-link"
        >
          커뮤니티 가기
        </a>
      </p>
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>음식 추가하기</h2>
            <input
              type="text"
              value={foodName}
              onChange={(e) => setFoodName(e.target.value)}
              placeholder="음식 이름을 입력하세요"
              className="food-input"
            />
            <div className="modal-buttons">
              <button className="add-button" onClick={handleAddFood}>
                추가하기
              </button>
              <button className="close-button" onClick={handleCloseModal}>
                닫기
              </button>
            </div>
          </div>
        </div>
      )}

      <Search onSearch={handleSearch} />

      {Array.isArray(searchResult) && searchResult.length > 0 ? (
        <div className="search-result">
          <h2>검색 결과</h2>
          <div className="food-card-container">
            {searchResult.map((food) => (
              <FoodCard key={food.id} food={food} />
            ))}
          </div>
        </div>
      ) : (
        <p className="no-results-message">검색 결과가 없습니다.</p>
      )}

      <div className="popular-section">
        <h2>속편한 음식 TOP 3</h2>
        <div className="food-card-container">
          {popularFoods.map((food) => (
            <FoodCard key={food.id} food={food} />
          ))}
        </div>
      </div>

      <div className="all-foods-section">
        <h2>모든 음식</h2>
        <div className="food-card-container">
          {foods.map((food) => (
            <FoodCard key={food.id} food={food} />
          ))}
        </div>
      </div>
      <Ranking />
    </div>
  );
};

export default Home;